import React from "react";
import { useTranslation } from "react-i18next";
import "./LoadingScreen.css";

const LoadingScreen = ({ show, message = null }) => {
  const { t } = useTranslation();
  const messageText = message || t("loading.initializing");

  if (!show) return null;

  return (
    <div
      className="loading-screen"
      role="status"
      aria-live="polite"
      aria-label={t("loading.ariaLabel")}
    >
      <div className="loading-screen-content">
        <div className="loading-spinner" aria-hidden="true"></div>
        <p className="loading-message">{messageText}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
